/**
 * The "Move to" section of a row's overflow menu, shared by the Tests, Skill Sheets and Documents tabs so a
 * class-level item can be moved to a session (and back) the same way everywhere.
 */
import { sessionDateInfo } from "../pages/courseHub/sessionsList/sessionsModel";

export { sessionDateInfo };

/** "S01 · Tue, Sep 22" — the session's name, then its weekday and date when known. */
export function sessionOptionLabel(session) {
  const name = session.sessionNumber || `Session ${session.id}`;
  const info = sessionDateInfo(session);
  return info ? `${name} · ${info.weekday}, ${info.month} ${info.day}` : name;
}

/**
 * Where `item` can go: the class level (when it is on a session) and every other session. Each target is
 * { sessionId: number | null, label, kind: "class" | "session", locked }.
 */
export function moveTargets(item, sessions, classLabel) {
  const current = item?.sessionId ?? null;
  const targets = [];
  if (current !== null) targets.push({ sessionId: null, label: classLabel, kind: "class", locked: false });
  (sessions || [])
    .filter((s) => s.id !== current)
    .forEach((s) => targets.push({ sessionId: s.id, label: sessionOptionLabel(s), kind: "session", locked: Boolean(s.locked) }));
  return targets;
}

/**
 * KebabMenu entries for the Move section: a separator, a "Move to" heading, then one entry per open target.
 * Empty when the item cannot be moved (`locked`) or has nowhere to go. `icon(kind)` renders a target's icon.
 */
export function moveMenuItems({ item, sessions, onMove, locked, classLabel, icon }) {
  if (locked || !onMove) return [];
  const open = moveTargets(item, sessions, classLabel).filter((t) => !t.locked);
  if (open.length === 0) return [];
  return [
    { separator: true },
    { heading: "Move to" },
    ...open.map((t) => ({ icon: icon(t.kind), label: t.label, onSelect: () => onMove(item, t.sessionId) })),
  ];
}
